import { FaSpinner } from 'react-icons/fa';
import styles from './spinner.module.scss';

export default function Spinner({ className }: { className?: string }) {
  return <FaSpinner className={`${styles.spinner} ${className}`} />;
}
